import { Page } from './pages';

import { PATH } from '../../constants';

export default {
  component: Page,
  name: 'Report',
  path: PATH.REPORT
};
